import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Impact from "./components/Impact";

import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";

import "./App.css";

function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Projects /> 
        <Impact />
        <ContactUs />
      </main>
      <Footer />
    </>
  );
}

export default App;
